export default {
  highcharts: {
    decimalPoint: ',',
    downloadJPEG: 'Pobierz obraz JPEG',
    downloadPDF: 'Pobierz dokument PDF',
    downloadPNG: 'Pobierz obraz PNG',
    downloadSVG: 'Pobierz obraz SVG',
    exportButtonTitle: 'Eksport',
    forexRate: 'Kurs średni FOREX',
    loading: 'Ładowanie...',
    months: [
      'Styczeń',
      'Luty',
      'Marzec',
      'Kwiecień',
      'Maj',
      'Czerwiec',
      'Lipiec',
      'Sierpień',
      'Wrzesień',
      'Październik',
      'Listopad',
      'Grudzień',
    ],
    printButtonTitle: 'Drukowanie',
    rangeSelectorFrom: 'Od',
    rangeSelectorTo: 'Do',
    rangeSelectorZoom: 'Przybliżenie',
    rateTypes: {
      ask: 'Najlepsza oferta sprzedaży',
      bid: 'Najlepsza oferta kupna',
      forex: 'Średni kurs na świecie',
    },
    resetZoom: 'Reset',
    resetZoomTitle: 'Reset',
    shortMonths: ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru'],
    thousandsSep: ' ',
    weekdays: ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'],
    wtBestAsk: 'Najlepsza oferta sprzedaży',
    wtBestBid: 'Najlepsza oferta kupna',
    seriesError: 'Debe seleccionar al menos una opción',
  },
  calculator: {
    title: 'Calcular el ahorro en Walutomat',
    forBuy: 'para',
    unsupportedPair: 'Actualmente no ofrecemos tarifas para el par de divisas seleccionado.',
    spinnerError: {
      generic: 'Hubo un problema con la descarga de datos',
      toManyRequests:
        'La calculadora no está disponible en este momento. Inténtalo de nuevo más tarde o ponte en contacto con el <a href="https://www.walutomat.com/es/pongase-en-contacto-con/">Servicio de Atención al Cliente</a>.',
    },
    commissionWT: 'Comisión de Walutomat',
    ctaButton: 'Cambiar',
    amountText: 'Importe',
  },
  dashboard: {
    canEditPost: 'Możesz edytować wpis',
    postExists: 'Wpis o takim tytule już istnieje',
    postNotExists: 'Wpis o takim tytule nie istnieje',
    emptyPostTitle: 'Dodaj tytuł wpisu',
    error: 'Coś poszło nie tak :(',
  },
  widgetCalculator: {
    title: 'Comprueba los tipos de cambio y{{nbsp}}cambia divisas en{{nbsp}}Walutomat – rápido y{{nbsp}}ventajoso.',
    actualRate: 'Tipo de cambio actual',
    buySelect: 'Comprar',
    sellSelect: 'Vendo',
    exchangeAmountSellLabel: 'Recibirás',
    exchangeAmountBuyLabel: 'Depósito',
    commission: 'Comisión promocional ({{commission}}%)',
  },
  formValidation: {
    emptyField: 'El campo no puede estar vacío',
    requiredField: 'El campo es obligatorio',
    requireAllFields: 'Todos los campos deben estar completos',
    passwordToShort: 'La contraseña debe tener 8 caracteres',
    emailNotValid: 'El campo debe contener una dirección de correo electrónico válida',
    emailReserved: 'La dirección de correo electrónico ya está ocupada',
    emailUnregistered: 'No encontramos tu dirección de correo electrónico en nuestra base de datos de clientes.',
    markField: 'Marque al menos una de las casillas',
    serverUnknownError: 'Error de comunicación con el servidor',
    invalidCharacters: 'El campo contiene caracteres no válidos',
    phoneNotValid: 'El número de teléfono es incorrecto',
    checkBoxBelow: 'Por favor, marque la casilla de abajo para enviar un mensaje',
    promocodeInvalid: 'Código de promoción no válido',
    newsletterAlreadySubscribed: 'Este correo electrónico ya está suscrito al boletín.',
  },
  password: {
    show: 'mostrar',
    hide: 'ocultar',
  },
  howItWorks: {
    showButton: 'Mostrar más',
    hideButton: 'Mostrar menos',
  },
  rateCalculator: {
    baseInputLabel: 'Mam',
    counterInputLabel: 'Otrzymam',
    counterInputTooltip: 'Uwzględnia prowizję {{commission}}%',
    ctaAlert: 'Ustaw alert',
  },
  esim: {
    searchPlaceholder: 'Buscar un país o región...',
    searchAriaLabel: 'Buscar un país o región',
    searchMinChars: 'Introduce <b>al menos 3 caracteres</b> para ver los resultados.',
    searchNoResults: '<b>Sin resultados.</b> No encontramos el país que buscas.',
    searchError: '<b>Se ha producido un error.</b> No se pudo cargar la lista de ofertas.',
  },
}
